// 导出版本号
export const version = "1.1.4";

export * from './core/base';
export { AbstractComponent } from './core/base';
export * from './core/type';
export * from './scrollbar';
export { ScrollBar } from './scrollbar/scrollbar';
export { loadScrollbar } from './scrollbar/module';
export * from './tag';
export * from './poptip';
export { loadPoptip } from './poptip/module';
export * from './crosshair';
export { LineCrosshair } from './crosshair/line';
export { CircleCrosshair } from './crosshair/circle';
export { SectorCrosshair } from './crosshair/sector';
export { PolygonCrosshair } from './crosshair/polygon';
export * from './label';
export { DataLabel } from './label/dataLabel';
export { registerSymbolDataLabel } from './label/symbol';
export * from './axis';
export { LineAxis } from './axis/line';
export { CircleAxis } from './axis/circle';
export { continuousTicks } from './axis/tick-data/continuous';
export { polarAngleAxisDiscreteTicks } from './axis/tick-data/discrete/polar-angle';
export * from './axis/grid';
export { LineAxisGrid } from './axis/grid/line';
export { CircleAxisGrid } from './axis/grid/circle';
export * from './segment';
export { Segment } from './segment/segment';
export * from './data-zoom';
export { DataZoom } from './data-zoom/data-zoom';
export * from './marker';
export { MarkLine, registerMarkLineAnimate } from './marker/line';
export { MarkArea, registerMarkAreaAnimate } from './marker/area';
export { MarkArcLine, registerMarkArcLineAnimate } from './marker/arc-line';
export { MarkArcArea, registerMarkArcAreaAnimate } from './marker/arc-area';
export { MarkPoint, registerMarkPointAnimate } from './marker/point';
export * from './pager';
export * from './legend';
export { ColorContinuousLegend } from './legend/color/color';
export { SizeContinuousLegend } from './legend/size/size';
export * from './title';
export { Title } from './title/title';
export * from './indicator';
export { Indicator } from './indicator/indicator';
export * from './slider';
export * from './link-path';
export * from './player';
export { DiscretePlayer } from './player/discrete-player';
export { ContinuousPlayer } from './player/continuous-player';
export { PlayerEventEnum } from './player/type/event';
export * from './brush';
export { Brush } from './brush/brush';
export { IOperateType } from './brush/type';
export * from './tooltip';
export * from './timeline';
export * from './interface';
export * from './jsx';
export * from './checkbox';
export * from './radio';
export * from './empty-tip';
export * from './weather';
export * from './util';
export { labelSmartInvert } from './util/label-smartInvert';
export * from './switch';
export * from './label-item';
export * from './table-series-number';
